/* eslint-disable @typescript-eslint/no-explicit-any */
import request from "@/request/index";

const AREA_ALL = '/api/area/all';
const TRADE_ALL = '/api/trade/list';
const AUTHOR_MCN = '/api/author/mcn';
const AUTHOR_UPDATE_NUM = '/api/author/update-num';
const AUTHOR_EXPORT_TEMPLATE = '/api/author/export-template'
const DEPARTEMENT_TREE_LIST = '/api/department/tree-list';

/**
 * @function 查询部门列表
 * @param param 
 * @returns 
 */
export const postDepartmentList = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: '/api/department/list',
            method: 'post',
            data: param,
            headers: {
                
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 查询树形结构列表
 * @param param 
 * @returns 
 */
export const getTreeList = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: DEPARTEMENT_TREE_LIST,
            method: 'post',
            data: param,
            headers: {
                
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 查询更新次数
 * @param param 
 * @returns 
 */
export const getAuthorUpdate = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: AUTHOR_UPDATE_NUM,
            method: 'get',
            params: param,
            headers: {
                
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 获取mcn
 * @param param 
 * @returns 
 */
export const getAuthorMcn = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: AUTHOR_MCN,
            method: 'get',
            params: param,
            headers: {
                
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 获取地区
 * @param param 
 * @returns 
 */
export const getAreaAll = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: AREA_ALL,
            method: 'get',
            params: param,
            headers: {
                
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 获取行业列表
 * @param param 
 * @returns 
 */
export const getTradeList = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: TRADE_ALL,
            method: 'get',
            params: param,
            headers: {
                
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

/**
 * @function 获取导出字段
 * @param param 
 * @returns 
 */
export const getAuthorExportTemplate = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: AUTHOR_EXPORT_TEMPLATE,
            method: 'get',
            params: param,
            headers: {
                
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};


/**
 * @function 聚光回调
 * @param param 
 * @returns 
 */
export const getCallbackAuthJuguang = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: '/callback/auth/juguang',
            method: 'get',
            params: param,
            headers: {
                
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};
